<script>
  import PageSectionHeader from "$lib/components/Page/PageSectionHeader.svelte";
  import Bleed from "$lib/components/Bleed.svelte";
  import RichText from "$lib/components/RichText.svelte";
  import { buildSrc } from "$lib/utilities";

  export let eyebrow;
  export let headline;
  export let backgroundImage;
  export let body;
  export let containerClass;
  export let headlineClass;
  export let contentClass;
  export let eyebrowClass = "text-neutral-600";
  export let componentMap;

  const backgroundImageUrl = buildSrc(backgroundImage?.fields.imageAsset, { w: 3000, fm: "webp" });
  const backgroundImageStyle = backgroundImageUrl
    ? `background-image: url('${backgroundImageUrl}'); background-repeat: no-repeat; background-size: cover; background-position: center;`
    : "";
</script>

<div class="section" data-self-spaced={true}>
  <Bleed
    fullWidth
    contentClasses="px-24 lg:px-72 py-48 md:py-72"
    fullWidthClasses={containerClass}
    fullWidthStyles={backgroundImageStyle}
  >
    <div class="w-full {containerClass}">
      {#if headline}
        <div class="section-header-container">
          <PageSectionHeader
            {eyebrow}
            {headline}
            {headlineClass}
            eyebrowClass="pt-0 {eyebrowClass}"
          />
        </div>
      {/if}

      <div class="section-body {contentClass}">
        {#if body}
          <RichText node={body} {componentMap} />
        {:else}
          <slot />
        {/if}
      </div>
    </div>
  </Bleed>
</div>
